import {Component, HostBinding, Input} from '@angular/core';
import {ExampleSJ} from '../../models/example-sj.model';
import {IsHanja} from '../../defines/common.func';

export type CharInfo = {
  text: string;
  seungjoCss: string;
  textCss: string;
  highlightCss: string;
};

@Component({
  selector: 'app-example-disp',
  templateUrl: './example-disp.component.html',
  styleUrls: ['./example-disp.component.scss']
})
export class ExampleDispComponent {
  @HostBinding('class.small') @Input() small = false;
  words: Array<Array<CharInfo>> = [];

  private _exampleSJ: ExampleSJ | null = null;

  @Input()
  set exampleSJ(value: ExampleSJ | null) {
    this._exampleSJ = value;
    this.words = this.parseWords(value);
  }
  get exampleSJ(): ExampleSJ | null {
    return this._exampleSJ;
  }

  private parseWords(sj: ExampleSJ | null): Array<Array<CharInfo>> {
    if (!sj?.example) return [];

    const chars = Array.from(sj.example);
    const words: Array<Array<CharInfo>> = [];
    let currentWord: Array<CharInfo> = [];

    chars.forEach((c, i) => {
      // 공백/끊어읽기(/)/장단(:)은 글자가 아닌 표시 기호이므로 강조 대상에서 제외한다.
      const isGlyph = c !== ' ' && c !== '/' && c !== ':';
      const info: CharInfo = {
        text: c === '/' ? ' ' : c,
        seungjoCss: (c !== ' ' && sj.seungjo?.[i]) ? `ic-intonation-${sj.seungjo[i]}` : '',
        textCss: c === ' ' ? 'space' : c === '/' ? 'slash' : c === ':' ? 'jangdan' : IsHanja(c) ? 'hanja-size' : '',
        highlightCss: isGlyph ? this.getHighlightClass(sj.highlight?.[i]) : '',
      };

      if (c === ' ') {
        if (currentWord.length > 0) {
          currentWord.push(info);
          words.push(currentWord);
          currentWord = [];
        } else if (words.length > 0) {
          words[words.length - 1].push(info);
        }
      } else {
        currentWord.push(info);
      }
    });

    if (currentWord.length > 0) {
      words.push(currentWord);
    }

    return words;
  }

  // word-disp의 GetHightlightClass와 동일 규칙: '1'=highlight, '2'=highlight2, 그 외/누락=강조 없음.
  private getHighlightClass(value: string | undefined): string {
    switch (value) {
      case '1':
        return 'highlight';
      case '2':
        return 'highlight2';
      default:
        return '';
    }
  }
}
